<template>
    <div>
        <div class="MeasuresCount">
            <Measure  ></Measure>
            <DistanceMeasurement></DistanceMeasurement>
            <labels></labels>
            <DeleteLabel></DeleteLabel>
        </div>
    </div>
</template>
<script>
import Measure from "@/views/Measure/Measure.vue";
import DistanceMeasurement from "@/views/DistanceMeasurement/DistanceMeasurement.vue";
import labels from "@/views/Labels/labels.vue";
import DeleteLabel from "@/views/DeleteLabel/DeleteLabel.vue";

export default {
    components: {
    DistanceMeasurement,
    Measure,
    labels,
    DeleteLabel
  },
    data(){
        return {

        }
    }
}
</script>
<style scoped lang="scss">
.MeasuresCount{
   display: flex;
   flex-direction: column;
   flex-wrap: wrap;

   >div{
    margin: 5px;
   }
}
</style>